import { ToolUIPart } from 'ai';

import { PathwayUITools } from '@/routes/smart-search/types';

interface ToolProps {
  part: ToolUIPart<PathwayUITools>;
}

const Tool: React.FC<ToolProps> = ({ part }) => {
  console.log(part.title, part.state);
  return <div></div>;
};

export default Tool;
